export default "__VITE_ASSET__1e07b7eb__"